import { Component, OnInit } from '@angular/core';
import { SupersetDashboardService } from '../service/superset-dashboard.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dash-menu',
  templateUrl: './dash-menu.component.html',
  styleUrls: ['./dash-menu.component.scss']
})
export class DashMenuComponent implements OnInit {
  public superSetSubMenuDashCardCont:any[] = [];
  public errorText:string = "No Dashboards Found";

  constructor(
    private superSetService: SupersetDashboardService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getSupersetDashboardMenu();
  }


  navigateTo(menu: any){
    if(menu && menu.heading && menu.uuid){
      this.router.navigate(['/dash-suite', menu.heading.split(' ').join('-').toLowerCase(), menu.uuid]);
    }
  }


  getSupersetDashboardMenu(){
    this.superSetSubMenuDashCardCont = []
    this.superSetService.getSuperSetSubMenuDash().subscribe((res:any)=>{
      if(res && res.status && res.data && res.data.length > 0){
        this.superSetSubMenuDashCardCont = res.data || [];
      }
    });
  }

}
